import React, { Fragment } from 'react'
import Link from 'gatsby-link'

import TwoColumns from 'components/twoColumns'
import SectionHeading from 'components/sectionHeading'
import Project from 'components/project'

import GtocLogo from 'img/gtoclogo'
import siemensLogo from 'img/siemenslogo'
import auvLogo from 'img/auvlogo'
import teamIndusLogo from 'img/teaminduslogo'
import ibikeLogo from 'img/ibikelogo'

const GtocXLink = <Link to="/gtocx">Read More</Link>
const SiemensLink = <Link to="/siemens">Read More</Link>
const IBikeLink = <Link to="/ibike">Read More</Link>
const AuvLink = <Link to="/auv">Read More</Link>
const TeamIndusLink = <Link to="/teamindus">Read More</Link>

const Work = () => {
  return (
    <TwoColumns
      wide
      leftColumn={<SectionHeading>Work</SectionHeading>}
      rightColumn={
        <Fragment>
          <Project
            logo={GtocLogo()}
            title="GTOC X : Karmarkar’s Gang "
            abstract="10th Global Trajectory Optimization Competition"
            link={GtocXLink}
          />
          <Project
            logo={siemensLogo()}
            title="Siemens Digital Industries Software"
            abstract="Software Engineer, NX Integration team"
            link={SiemensLink}
          />
          <Project
            logo={teamIndusLogo()}
            title="Team Indus"
            abstract="Algorithm to detect and isolate faults in spacecraft and recover to complete its mission"
            link={TeamIndusLink}
          />
          <Project
            logo={ibikeLogo()}
            title="i-Bike, Autonomous bicycle"
            abstract="Autonomous solution to last mile transportation system"
            link={IBikeLink}
          />
          <Project
            logo={auvLogo()}
            title="Autonomous underwater vehicle"
            abstract="Lead a team of undergraduates to build a fully autonomous underwater vehicle for research and competitive purpose."
            link={AuvLink}
          />
        </Fragment>
      }
    />
  )
}

export default Work
